<script lang="ts">
    import { Link, useForm, page } from '@inertiajs/svelte';
    import SocialLoginButtons from '../components/SocialLoginButtons.svelte';
    import { register } from '@/routes';
    import { request } from '@/routes/password';
    import logo from '../../images/logo.png';

    const form = useForm({ email: '', password: '', remember: false });

    const errors = $derived($page?.props?.errors ?? {});
    const status = $derived($page?.props?.flash?.status);

    function submit(e: SubmitEvent) {
        e.preventDefault();
        $form.post('/login');
    }
</script>

<svelte:head>
    <title>Log In — Case of the Day</title>
</svelte:head>

<div class="min-h-screen flex flex-col items-center justify-center bg-gray-950">
    <img src={logo} alt="Case of the Day" class="h-24 w-24 mb-6" />
    <div class="bg-gray-900 rounded-lg shadow border border-gray-700 p-8 w-full max-w-lg">
        <h1 class="text-2xl font-bold text-gray-100 mb-6 text-center">Sign In</h1>

        <SocialLoginButtons mode="signin" />

        {#if status}
            <div class="mb-4 rounded-md bg-green-50 border border-green-200 p-3 text-sm text-green-700">
                {status}
            </div>
        {/if}

        <form onsubmit={submit} class="space-y-4">
            <div>
                <label class="block text-sm font-medium text-gray-300 mb-1">Email</label>
                <input
                    bind:value={$form.email}
                    type="email"
                    autocomplete="email"
                    required
                    class="w-full border rounded-md px-3 py-2 text-sm bg-gray-800 text-gray-100 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-colors {errors.email ? 'border-red-500' : 'border-gray-700'}"
                />
                {#if errors.email}<p class="text-red-500 text-sm mt-1">{errors.email}</p>{/if}
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-300 mb-1">Password</label>
                <input
                    bind:value={$form.password}
                    type="password"
                    autocomplete="current-password"
                    required
                    class="w-full border rounded-md px-3 py-2 text-sm bg-gray-800 text-gray-100 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500 transition-colors {errors.password ? 'border-red-500' : 'border-gray-700'}"
                />
                {#if errors.password}<p class="text-red-500 text-sm mt-1">{errors.password}</p>{/if}
            </div>
            <button type="submit" disabled={$form.processing} class="w-full bg-cyan-600 text-white py-2 rounded-md text-sm font-medium hover:bg-cyan-500 disabled:opacity-50 transition-colors">
                Sign In
            </button>
        </form>

        <div class="mt-4 flex items-center justify-between text-sm">
            <Link href={request()} class="text-gray-400 hover:text-cyan-400 transition-colors">Forgot password?</Link>
            <span class="text-gray-400">No account? <Link href={register()} class="text-cyan-400 hover:text-cyan-300 hover:underline">Register</Link></span>
        </div>
    </div>
</div>
